import React from "react";
import {Link} from "react-router";

import FormItem from "./FormItem";
import Right from "./Right";
import Panel from "./Panel";
import langs from "./langs/appIndex";

import {api, hashCode, arrMove} from "./baseFunctions";
import {history} from "../store";
import _ from "lodash";

export default class OBSsheets extends React.Component {
	constructor(){
		super();
		this.getData = this.getData.bind(this);
		this.startEmpty = this.startEmpty.bind(this);
		this.extraAction = this.extraAction.bind(this);
		this.updateVal = this.updateVal.bind(this);
		this.addEmpty = this.addEmpty.bind(this);
		this.keepID = this.keepID.bind(this);
		this.types = {
			"checkbox": "Multi-select",
			"select": "Select",
			"textArea": "Flere linjers tekstfelt",
			"text": "Tekstfelt",
			"date": "Dato og tidspunkt",
			"deplist": "Tildel til afdeling",
			"staticBox": "Statisk tekstbox",
		};
		this.state = {
			data: false,
			editing: false,
			editData: false,
			orgComps: false,
			newSheet: false,
			removeIDs: [],
			removeExtraIDs: [],
		};
	}
	componentWillMount(){
		this.getData();
		if(this.props.route.path.indexOf("/obsSheet/edit/") !== -1)
		{
			this.setActive(this.props.params.id);
		}else if(this.props.route.path.indexOf("/obsSheet/new") !== -1)
		{
			this.startEmpty();
		}
	}
	startEmpty()
	{
		console.log("Starting empty");
		this.setState({
			newSheet: {id: "NEW", name: ""},
			editData: [],
			orgComps: [],
			removeIDs: [],
			removeExtraIDs: [],
		});
	}
	getData()
	{
		api("POST", {"type": "getOBSsheets"}, (d) => {
			if(!d.error)
			{
				this.setState({
					data: d.data,
				});
			}
		}, this.props.auth, 1);
	}
	setActive(id)
	{
		api("POST", {"type": "getOBSsheet", id}, (d) => {
			if(!d.error)
			{
				this.setState({
					editData: _.cloneDeep(d.data),
					orgComps: _.cloneDeep(d.data),
					removeIDs: [],
					removeExtraIDs: [],
				});
			}
		}, this.props.auth, 1);
	}
	updateVal(key, name, val, deepKey, deepName)
	{
		if(key === "")
		{

		}else{
			const data = [...this.state.editData];
			if(deepName)
			{
				data[key][name][deepKey][deepName] = val;
			}else{
				data[key][name] = val;
			}

			this.setState({
				editData: data
			});
		}
	}
	move(key, type)
	{
		const newKey = type === "up" ? key - 1 : key + 1;
		this.setState({
			editData: arrMove(key, newKey, this.state.editData),
			orgComps: arrMove(key, newKey, this.state.orgComps),
		});
	}
	keepID(me, other)
	{
		//console.log("keepID", me.type, other.type);
		/*console.log("keepID", me, other);
		console.log("keepID", me.type, other.type);*/
		if(me.type !== other.type)
		{
			return false;
		}
		return true;
	}
	extraAction(action, id, key)
	{
		let newState = [...this.state.editData];
		let parent = newState[id];
		console.log(parent);
		switch(action)
		{
			case "add":
				newState[id].extras.push({
					id: "NEW",
					parentID: parent.id,
					parentID2: "obsComponent",
					type: "checkbox",
					value: "",
					value2: ""
				});
			break;
			case "remove":
				let temp = parent.extras[key];
				if(temp.id !== "NEW")
				{
					this.setState({
						removeExtraIDs: [...this.state.removeExtraIDs, temp.id]
					});
				}
				newState[id].extras = parent.extras.filter((d, keyz) => key !== keyz);
			break;
			case "edit":

			break;
		}
		this.setState({
			editData: newState
		});
	}
	addEmpty(){
		this.setState({
			editData: [...this.state.editData, {
				id: "NEW",
				type: Object.keys(this.types)[0],
				langCode: Object.keys(langs[this.props.lang])[0],
				extras: [],
			}],
			orgComps: [...this.state.orgComps, {
				type: "",
			}],
		});
	}
	save(resetIDs)
	{
		let comps = [...this.state.editData];
		let isNew = this.props.route.path === "/obsSheet/new";
		if(resetIDs)
		{
			isNew = true;
			comps = comps.map((d) => {
				d.id = "NEW";
				d.extras = d.extras.map((d2) => {
					d2.id = "NEW";
					return d2;
				});
				return d;
			});
		}
		 api("POST", {"type": (isNew ? "addOBSsheet" : "updateOBSsheet"), "data": {"name": this.refs.name.value, comps, removeIDs: this.state.removeIDs, removeExtraIDs: this.state.removeExtraIDs, id: (isNew ? "NEW" : this.props.params.id)}}, (d) => {
      if(!d.error)
      {
        this.getData();
        history.push("/obsSheet");
      }
      if(d.msg)
      {
        alert(d.msg);
      }
    }, this.props.auth, 1);
	}
	render(){
		const LANG = langs[this.props.lang];
		const IS_EDITING = this.props.route.path.indexOf("/obsSheet/edit/") !== -1;
		let EDIT_DATA = IS_EDITING && this.state.data ? this.state.data.find((d) => d.id === this.props.params.id) : false;
		if(this.props.route.path === "/obsSheet/new")
		{
			EDIT_DATA = this.state.newSheet;
		}
		console.log(EDIT_DATA);
		const TYPES = this.types;
		console.log("Types", TYPES, EDIT_DATA);
		return (
			<Right title="Observations ark">
      	{
      		EDIT_DATA ? 
      			<Panel title={IS_EDITING ? "Ret ark" : "Nyt ark"}>
      				<FormItem name="Navn" must={true}>
      					<input type="text" required={true} className="form-control col-md-7 col-xs-12" ref="name" defaultValue={EDIT_DATA.name} key={EDIT_DATA.name}/>
      				</FormItem>
    					<div className="form-group">
                <label className="control-label col-md-12 col-sm-12 col-xs-12" style={{"textAlign": "left"}} htmlFor="last-name">
                    Komponenter
                </label>
                <div className="col-md-12 col-sm-12 col-xs-12">
                  <table className="table table-striped jambo_table bulk_action">
                    <thead>
                      <tr>
                        <td>ID</td>
                        <td>Type</td>
                        <td>Tekst</td>
                        <td>
                        	<button style={{color: "#000"}} 
                        		onClick={this.addEmpty}>
                        		+
                        	</button>
                        </td>
                      </tr>
                    </thead>
                    <tbody key={this.state.editData.length}>
                    	{
                    		this.state.editData ?
                    			this.state.editData.map((d, key) => {
									let fixCheck = d.type === "deplist" && d.extras.length > 0 && typeof d.extras[0] === "object";
                    				return (<tr key={hashCode(JSON.stringify(d))}>
                    				<td>{this.keepID(d, this.state.orgComps[key]) ? d.id : "NEW"}</td>
                    				<td>
                    					<select defaultValue={d.type} className="control-label col-md-12 col-sm-12 col-xs-12" onChange={(e) => this.updateVal(key, "type", e.target.value)}>
                    						{
                    							Object.keys(TYPES).map((d, key) => <option value={d} key={key}>{TYPES[d]}</option>)
                    						}
                    					</select>
                    				</td>
                    				<td>
                    					<select defaultValue={d.langCode} className="control-label col-md-12 col-sm-12 col-xs-12" onChange={(e) => this.updateVal(key, "langCode", e.target.value)}>
                    						{
                    							Object.keys(LANG).map((d, key) => <option value={d} key={key}>{LANG[d]}</option>)
                    						}
                    					</select>
                    					{
                    						d.type === "deplist" ?
                    							<div>
                    									<b>Afdeling IDs:</b>
                    									<input placeholder="10,20,11,2" defaultValue={fixCheck ? d.extras.map(d => d.value) : d.extras} className="control-label col-md-12 col-sm-12 col-xs-12" onBlur={(e) => this.updateVal(key, "extras", e.target.value.indexOf(",") !== -1 ? e.target.value.split(",") : [e.target.value])}/>
                    							</div>
                    						: null
                    					}
                    					{
                    						["checkbox", "select"].indexOf(d.type) !== -1 ?
                    							<table className="table table-striped jambo_table bulk_action" style={{marginTop: "30px"}}>
                    								<thead>
	                    								<tr>
	                    									<th>DK</th>
	                    									<th>UK</th>
	                    									<th>
	                    										<button style={{color: "#000"}} onClick={() => this.extraAction("add", key)}>+</button>
	                    									</th>
	                    								</tr>
                    								</thead>
                    								<tbody>
                    									{
                    										d.extras.map((d, keyz) => <tr key={keyz}>
                    									<td>
                    										<input defaultValue={d.value} onBlur={(e) => this.updateVal(key, "extras", e.target.value, keyz, "value")}/>
                    									</td>
                    									<td>
                    										<input defaultValue={d.value2} onBlur={(e) => this.updateVal(key, "extras", e.target.value, keyz, "value2")}/>
                    									</td>
                    									<td>
                    										<button onClick={() => this.extraAction("remove", key, keyz)}>x</button>
                    									</td>
                    								</tr>)
                    									}
                    								</tbody>
                    							</table>
                    						: null
                    					}
                    				</td>
                    				<td>
                    					<button onClick={() => this.move(key, "up")} disabled={key <= 0}>&#8593;</button>
                    					<button onClick={() => this.move(key, "down")} disabled={key === (this.state.editData.length - 1)}>&#8595;</button>
                    					<button onClick={() => this.setState({
                    							editData: this.state.editData.filter((d, keyz) => keyz !== key),
                    							orgComps: this.state.orgComps.filter((d, keyz) => keyz !== key),
                    							removeIDs: d.ID !== "NEW" ? [...this.state.removeIDs, d.id] : this.state.removeIDs,
                    					})}>x</button>
                    				</td>
                    			</tr>);
                    			})
                    		: null
                    	}
                    </tbody>
                  </table>
                  <button style={{width: "100%", height: "50px", color: "#000"}} onClick={this.addEmpty}>
                  	+
                  </button>
                  <button style={{width: "100%", height: "50px", color: "#000", marginTop: "10px"}} onClick={() => this.save()}>
                  	Gem
                  </button>
                  <button style={{width: "100%", height: "50px", color: "#000", marginTop: "10px"}} onClick={() => this.save(1)}>
                  	Gem som nyt skema
                  </button>
                </div>
              </div>
      			</Panel>
      		: null
      	}
				<Panel title="Observations ark" add="/obsSheet/new" onAdd={this.startEmpty}>
						<table className="table table-striped jambo_table bulk_action" id="table">
		          <thead>
		              <tr className="headings">
		                  <th className="column-title">ID</th>
		                  <th className="column-title">Navn</th>
		                  <th className="column-title"></th>
		              </tr>
		          </thead>
		          <tbody>
		          {
		          	this.state.data ?
		          		this.state.data.map((d, key) => <tr key={key} className="headings">
		                  <td className="column-title">{d.id}</td>
		                  <td className="column-title">{d.name}</td>
		                  <td className="column-title">
		                  	<Link to={"/obsSheet/edit/" + d.id} onClick={() => this.setActive(d.id)}>Ret</Link>
		                  </td>
		              </tr>)
		          	: null
		          }
		          </tbody>
	        </table>
				</Panel>
			</Right>);
	}
}


// WEBPACK FOOTER //
// ./src/components/OBSsheets.js